var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c("div", { staticClass: "row gutter-md" }, [
        _c("div", {
          staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-5 col-xl-4"
        }),
        _vm.showReportPannel && _vm.userHasReports
          ? _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "q-collapsible",
                  {
                    staticClass: "accordion-modify",
                    attrs: { group: "somegroup" },
                    model: {
                      value: _vm.open,
                      callback: function($$v) {
                        _vm.open = $$v
                      },
                      expression: "open"
                    }
                  },
                  [
                    _c(
                      "template",
                      {
                        staticClass: "bg-secondary",
                        staticStyle: { padding: "0" },
                        slot: "header"
                      },
                      [
                        _c(
                          "q-card-title",
                          {
                            staticClass: "bg-secondary",
                            staticStyle: { width: "100%", padding: "10px" }
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "text-white q-headline" },
                              [
                                _c("q-icon", {
                                  attrs: { name: "fal fa-file-chart-line" }
                                }),
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t" +
                                    _vm._s(_vm.$t("business_inteligence")) +
                                    "\n\t\t\t\t\t\t"
                                )
                              ],
                              1
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c("q-card-separator", { staticStyle: { padding: "0" } }),
                    _c(
                      "q-item-main",
                      [
                        _c(
                          "q-tabs",
                          {
                            staticClass: "shadow-1",
                            attrs: { color: "secondary" },
                            on: { select: _vm.loadReports },
                            model: {
                              value: _vm.tab,
                              callback: function($$v) {
                                _vm.tab = $$v
                              },
                              expression: "tab"
                            }
                          },
                          [
                            _vm._l(_vm.reports, function(report, index) {
                              return _vm.showModule(report)
                                ? _c("q-tab", {
                                    key: "t" + index,
                                    attrs: {
                                      slot: "title",
                                      name: report,
                                      label: _vm.$t(report),
                                      default: _vm.getDefault(report)
                                    },
                                    slot: "title"
                                  })
                                : _vm._e()
                            }),
                            _vm._l(_vm.reports, function(report, index) {
                              return _vm.showModule(report)
                                ? _c(
                                    "q-tab-pane",
                                    {
                                      key: "tp" + index,
                                      staticClass: "q-px-lg q-pb-lg",
                                      attrs: { name: report }
                                    },
                                    [
                                      _c(
                                        "q-list",
                                        {
                                          attrs: {
                                            highlight: "",
                                            separator: "",
                                            link: ""
                                          }
                                        },
                                        [
                                          _vm._l(_vm.report_list, function(
                                            report,
                                            index
                                          ) {
                                            return _vm.report_list.length > 0
                                              ? _c(
                                                  "q-item",
                                                  {
                                                    key: "i" + index,
                                                    nativeOn: {
                                                      click: function($event) {
                                                        return _vm.showReport(
                                                          report
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("q-item-main", [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t" +
                                                          _vm._s(
                                                            _vm.$t(report.slug)
                                                          ) +
                                                          "\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          }),
                                          _vm.report_list.length === 0
                                            ? _c(
                                                "q-item",
                                                [
                                                  _c("q-item-main", [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "no_report_available"
                                                          )
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ])
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              ],
              1
            )
          : _vm._e()
      ]),
      _vm.showMyAcademy && _vm.report
        ? _c("div", { staticClass: "q-mt-lg" }, [
            _c("iframe", {
              staticStyle: {
                width: "100%",
                height: "80vh",
                "margin-top": "5px"
              },
              attrs: { src: _vm.report.url_original, frameborder: "0" }
            })
          ])
        : _vm._e(),
      _vm.data_studio_dashboards.length > 0
        ? _c(
            "div",
            { staticClass: "row gutter-md q-mt-md" },
            _vm._l(_vm.data_studio_dashboards, function(report, index) {
              return _c("div", { key: index, staticClass: "col-12" }, [
                _c("iframe", {
                  staticStyle: { width: "100%", height: "90vh" },
                  attrs: { src: report.url_original, frameborder: "0" }
                })
              ])
            }),
            0
          )
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "100vw",
              maxWidth: "100vw",
              minHeight: "100vh"
            }
          },
          model: {
            value: _vm.show_report,
            callback: function($$v) {
              _vm.show_report = $$v
            },
            expression: "show_report"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_report = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("reports")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "relative",
                      width: "100%",
                      height: "0px",
                      "padding-bottom": "56.25%"
                    }
                  },
                  [
                    _c("iframe", {
                      staticStyle: {
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: "100%",
                        height: "100%"
                      },
                      attrs: { src: _vm.report_url, frameborder: "0" }
                    })
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm.show_dashboard_modal
        ? _c("dashboard", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.show_dashboard_modal,
                expression: "show_dashboard_modal"
              }
            ],
            attrs: { showModule: _vm.showModule },
            on: {
              hide_dashboard_modal: function($event) {
                return _vm.hideDashboardModal()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }